import React from 'react';

const QUEST_TEAM_SIZES = {
  5:  [2, 3, 2, 3, 3],
  6:  [2, 3, 4, 3, 4],
  7:  [2, 3, 3, 4, 4],
  8:  [3, 4, 4, 5, 5],
  9:  [3, 4, 4, 5, 5],
  10: [3, 4, 4, 5, 5],
};

export default function ScoreTracker({ gameState }) {
  if (!gameState) return null;

  const { questResults, currentQuest, playerCount } = gameState;
  const sizes = QUEST_TEAM_SIZES[playerCount] || [0, 0, 0, 0, 0];

  return (
    <div className="score-tracker">
      {[0, 1, 2, 3, 4].map((i) => {
        const result = questResults[i];
        let cls = 'quest-pip';
        let label = sizes[i];

        if (result) {
          cls += result.success ? ' success' : ' fail';
          label = result.success ? '\u2713' : '\u2717';
        } else if (i === currentQuest) {
          cls += ' current';
        }

        const needsDoubleFail = playerCount >= 7 && i === 3;

        return (
          <div key={i} className={cls}>
            {needsDoubleFail && <span className="double-fail">2 fails</span>}
            {label}
            <span className="team-size">{sizes[i]}p</span>
          </div>
        );
      })}
    </div>
  );
}
